import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      icon: 'Database',
      label: 'Total Datasets',
      value: stats?.totalDatasets,
      change: '+12%',
      changeType: 'positive'
    },
    {
      icon: 'Download',
      label: 'Total Downloads',
      value: stats?.totalDownloads,
      change: '+28%',
      changeType: 'positive'
    },
    {
      icon: 'Users',
      label: 'Active Researchers',
      value: stats?.activeResearchers,
      change: '+5%',
      changeType: 'positive'
    },
    {
      icon: 'FileText',
      label: 'Publications',
      value: stats?.publications,
      change: '+18%',
      changeType: 'positive'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards?.map((stat, index) => (
        <div 
          key={index}
          className="bg-[var(--color-card)] rounded-lg p-6 border border-[var(--color-border)] hover:shadow-conservation animation-organic"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="w-12 h-12 rounded-lg bg-[var(--color-primary)]/10 flex items-center justify-center">
              <Icon name={stat?.icon} size={24} className="text-[var(--color-primary)]" />
            </div>
            <span className={`text-sm font-medium ${
              stat?.changeType === 'positive' ?'text-[var(--color-success)]' :'text-[var(--color-error)]'
            }`}>
              {stat?.change}
            </span>
          </div>
          <h3 className="text-3xl font-bold text-[var(--color-card-foreground)] mb-1">
            {stat?.value?.toLocaleString()}
          </h3>
          <p className="text-sm text-[var(--color-muted-foreground)]">{stat?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;